import { tryCatchHelper } from '../../../../helpers';
import { oneActividadesExtrasAction } from '../actividades_extras/ActividadesExtrasAction';
import {
  ACTIVO_ACTEXTRA_ESTUDIANTES,
  ALL_ACTEXTRA_ESTUDIANTES,
  LOADING_ALL_ACTEXTRA_ESTUDIANTES,
} from './ActExtraEstudiantesReducer';
import {
  allActExtraEstudiantesService,
  deleteActExtraEstudiantesService,
  oneActExtraEstudiantesService,
  saveActExtraEstudiantesService,
} from './ActExtraEstudiantesService';

export const allActExtraEstudiantesAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_ACTEXTRA_ESTUDIANTES, payload: true });
    const res = await allActExtraEstudiantesService(params);
    dispatch({ type: ALL_ACTEXTRA_ESTUDIANTES, payload: res.data });
    dispatch({ type: LOADING_ALL_ACTEXTRA_ESTUDIANTES, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_ACTEXTRA_ESTUDIANTES, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveActExtraEstudiantesAction = async (
  { dispatch, notify },
  idActividadExtra,
  id,
  data,
  params,
) => {
  try {
    const res = await saveActExtraEstudiantesService(id, data);
    notify(res.data.message);
    oneActividadesExtrasAction(dispatch, idActividadExtra);
    // await allActExtraEstudiantesAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoActExtraEstudiantesAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_ACTEXTRA_ESTUDIANTES, payload: data });
};

export const oneActExtraEstudiantesAction = async (dispatch, id) => {
  try {
    const res = await oneActExtraEstudiantesService(id);
    await setActivoActExtraEstudiantesAction(dispatch, res.data.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteActExtraEstudiantesAction = async (
  { dispatch, notify },
  idActividadExtra,
  id,
  params,
) => {
  try {
    const res = await deleteActExtraEstudiantesService(id);
    notify(res.data.message);
    await setActivoActExtraEstudiantesAction(dispatch, null);
    // await allActExtraEstudiantesAction(dispatch, params);
    oneActividadesExtrasAction(dispatch, idActividadExtra);
    return true;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
